import React from 'react';
import Image from 'next/image';

import { TimeAgo } from 'modules/global';

interface IProps {
  userName?: string;
  userImage?: string;
  createdAt?: number;
  specialty?: string;
}

const Avatar: React.FC<IProps> = ({ specialty, userImage, userName, createdAt }) => (
  <div className="flex items-center gap-2">
    <div className="flex min-h-16 min-w-16 max-h-16 max-w-16 items-center justify-center overflow-hidden rounded-full border border-gray-200 bg-gray-50">
      <Image
        src={userImage || '/images/default-no-logo.webp'}
        alt={userName?.slice(0, 1) || 'user profile avatar'}
        width={userImage ? 60 : 30}
        height={userImage ? 60 : 30}
        className="rounded-full object-contain"
        title="Kurs ishlab chiquvchining rasmi"
      />
    </div>
    <div className="flex flex-col">
      <span className="line-clamp-2 font-medium text-lg group-hover:text-green-500">{userName}</span>
      <div className="flex items-center space-x-2">
        <span className="line-clamp-1 text-sm text-gray-500">{specialty}</span>
        <span className='text-gray-500'>•</span>
        <span className="text-sm text-gray-500">{TimeAgo(createdAt)}</span>
      </div>
    </div>
  </div>
);

export default Avatar;
